import { ModelRow, UrlUtil } from "@mcleod/core";
import {
    DataHeaderProps, DataSourceMode, Panel, TableRow, TableRowExpansionEvent, TableSelectionEvent
} from "@mcleod/components";
import { CallinScriptDetailTable } from "./CallinScriptDetailTable";
import { AutogenLayoutCallinScriptList } from "./autogen/AutogenLayoutCallinScriptList";

export class CallinScriptList extends AutogenLayoutCallinScriptList {

    override async onLoad(): Promise<void> {
        this.tableCallinScriptTemplateList.doOnResolveRowEdit = async (updatedRow: ModelRow) => {
            this.tableCallinScriptTemplateList.selectedRow.expanded = false;
            return updatedRow;
        };

    }

    tableCallinScriptTemplateListOnRowExpand(event: TableRowExpansionEvent) {
        const tableRow: TableRow = event.target as TableRow;
        const expandPanel = event.expandComponentParent as Panel;
        const layoutCallinScriptDetail = expandPanel.findComponentById("layoutCallinScriptDetailTable") as CallinScriptDetailTable;
        const id = tableRow.data.get("id");
        layoutCallinScriptDetail.addLayoutLoadListener(async () => {
            layoutCallinScriptDetail.tableCallinList = this.tableCallinScriptTemplateList;
            layoutCallinScriptDetail.sourceCallinScriptTemplateDetail.search({ "callin_script_template_id": id});
        });
    }

    buttonCopyCallinScriptOnClick () {
        const selectedRow = this.tableCallinScriptTemplateList.selectedRow;
        if (selectedRow) {
            const urlParams: string[] = [];
            urlParams.push("mode=" + "add");
            urlParams.push("idToCopy=" + selectedRow.data.get("id"));
            const url = "lme/dispatch/CallinScriptStepper" + UrlUtil.buildQueryString(urlParams);
            const crudDecoratorProps = { pseudoNavigateUrl: url };
            const dataHeaderProps: Partial<DataHeaderProps> = {
                onExecute: (addedRow: ModelRow) => {
                    this.mainDataSource.search(this.mainDataSource.lastSearch);
                }
            };
            this.tableCallinScriptTemplateList.crudManager.showCrud(DataSourceMode.ADD, crudDecoratorProps,
                dataHeaderProps);
        }
    }

    sourceCallinScriptTemplateAfterExecution() {
        this.buttonCopyCallinScript.enabled = this.tableCallinScriptTemplateList.selectedRow !== null;
        this.tableCallinScriptTemplateList.setRowsExpanded(false);
    }

    tableCallinScriptTemplateListOnSelect(event: TableSelectionEvent) {
        const modelRow = event.newRow?.data;
        if (modelRow) {
            this.buttonCopyCallinScript.enabled = true;
        }
        else {
            this.buttonCopyCallinScript.enabled = false;
        }
    }
}
